import { render } from "./tickets-model.vue?vue&type=template&id=6e51c0d1"
import script from "./tickets-model.vue?vue&type=script&lang=js"
export * from "./tickets-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__